import {AJAX_ERROR} from '../../constants';
import LocalizableError, {ToJsonResult as LocalizableErrorToJsonResult} from '~/shared/src/base/LocalizableError';
import StackError, {ToJsonResult as StackErrorToJsonResult} from '~/shared/src/base/StackError';
import {ToJsonResult as ErrorToJsonResult} from '~/shared/src/utilities/error';

export type AjaxErrorAction = {
    /**
     * The action type
     */
    type : typeof AJAX_ERROR;

    /**
     * The error title
     */
    title : string;

    /**
     * The error message
     */
    message? : string;

    /**
     * The error number
     */
    code? : number;

    /**
     * The sub-errors
     */
    errors? : ( string | ErrorToJsonResult | LocalizableErrorToJsonResult | StackErrorToJsonResult )[];

    /**
     * The cancelFunction from CancelToken
     */
    cancelFn? : Function;

    /**
     * The uid of the component the requests belongs to
     */
    componentUid? : string;

    /**
     * The uid of the request itself
     */
    requestUid? : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} title                The error title
 * @param {String} message              The error message
 * @param {Number} code                 The error number
 * @param {any[]} errors                The sub-errors
 * @param {Function} cancelFn           The cancelFunction from CancelToken
 * @param {String} componentUid         The uid of the component the requests belongs to
 * @param {String} requestUid           The uid of the request itself
 *
 * @return {AjaxErrorAction}
 */
const ajaxError = ( title : string, message? : string, code? : number, errors? : any[], cancelFn? : Function, componentUid? : string, requestUid? : string ) : AjaxErrorAction => {
    return {
        type: AJAX_ERROR,
        title,
        message,
        code,
        errors,
        cancelFn,
        componentUid,
        requestUid
    };
}
export type AjaxError = typeof ajaxError;

export default ajaxError;
